import React from "react";
import styled from "styled-components";

//
import DemoCard from "./DemoCard";
import ColumnBlock from "./ColumnBlock";

export default function LearnColumns({checkAuth, course}) {



    return (
        <StyledLearnColumn className="learn_columns">
            <div className="container">
                {course ? course.categoryCourse.map((item) => (
                    <ColumnBlock
                        key={item.id}
                        title={item.title}
                        text={item.content}
                        courseList={item.leasons}
                        checkAuth={checkAuth}
                    />
                )) : null}
                {/*<ColumnBlock*/}
                {/*  title="Текст в HTML"*/}
                {/*  text="HTML предоставляет десятки правил для работы с текстом: от*/}
                {/*      создания блока текста, до сложных таблиц и вложенных списков.*/}
                {/*      Корректная разметка текста — один из ключевых навыков при работе с*/}
                {/*      сайтом."*/}
                {/*  courseList={[*/}
                {/*    { title: "Параграфы", to: "#", n: 6 },*/}
                {/*    { title: "Начертание текста", to: "#", n: 7 },*/}
                {/*    { title: "Заголовки", to: "#", n: 8 },*/}
                {/*    { title: "Списки", to: "#", n: 9 },*/}
                {/*    { title: "Вложенные списки", to: "#", n: 10 },*/}
                {/*  ]}*/}
                {/*  checkAuth={checkAuth}*/}
                {/*/>*/}
                {/*<ColumnBlock*/}
                {/*  title="Текст в HTML"*/}
                {/*  text="HTML предоставляет десятки правил для работы с текстом: от*/}
                {/*      создания блока текста, до сложных таблиц и вложенных списков.*/}
                {/*      Корректная разметка текста — один из ключевых навыков при работе с*/}
                {/*      сайтом."*/}
                {/*  courseList={[*/}
                {/*    { title: "Параграфы", to: "#", n: 6 },*/}
                {/*    { title: "Начертание текста", to: "#", n: 7 },*/}
                {/*    { title: "Заголовки", to: "#", n: 8 },*/}
                {/*    { title: "Списки", to: "#", n: 9 },*/}
                {/*    { title: "Вложенные списки", to: "#", n: 10 },*/}
                {/*  ]}*/}
                {/*  checkAuth={checkAuth}*/}
                {/*/>*/}
                {/*<ColumnBlock*/}
                {/*  title="Текст в HTML"*/}
                {/*  text="HTML предоставляет десятки правил для работы с текстом: от*/}
                {/*      создания блока текста, до сложных таблиц и вложенных списков.*/}
                {/*      Корректная разметка текста — один из ключевых навыков при работе с*/}
                {/*      сайтом."*/}
                {/*  courseList={[*/}
                {/*    { title: "Параграфы", to: "#", n: 6 },*/}
                {/*    { title: "Начертание текста", to: "#", n: 7 },*/}
                {/*    { title: "Заголовки", to: "#", n: 8 },*/}
                {/*    { title: "Списки", to: "#", n: 9 },*/}
                {/*    { title: "Вложенные списки", to: "#", n: 10 },*/}
                {/*  ]}*/}
                {/*  checkAuth={checkAuth}*/}
                {/*/>*/}

                <DemoCard/>
            </div>
        </StyledLearnColumn>
    );
}

const StyledLearnColumn = styled.section`
  .learn_columns_title {
    font-size: 1.5rem;
  }

  .learn_group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: 0.25rem;
  }

  .learn_group_item {
    position: relative;
    display: flex;
    color: #212529;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
  }

  .learn_group_item + .learn_group_item {
    border-top-width: 0;
  }

  .learn_group_item{
    color: #0d6efd;
    display: block;
    width: 100%;
    padding: 1rem;
    cursor: pointer;
  }

  .learn_group_item:hover {
    color: #0a58ca;
  }

  .learn_columns_block {
    margin-top: 48px;
  }

  .learn_columns {
    margin-bottom: 144px;
  }
`;
